export default "__VITE_ASSET__09525100__"